import React, { useEffect, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { Outlet } from 'react-router'
import clsx from 'clsx'

import { useMainGlobalContext } from '../../context/GlobalContext'
import { useGetUserWithTokenQuery } from '../../services/apiSlice'
import Overlay from '../Overlay'
import Banner from '../../components/main/Banner'
import Spinner from '../../components/loading/Spinner'
import CustomErrorDisplayWrapper from '../../components/custom/wrapper/CustomErrorDisplayWrapper'
import { isCurrentUser } from '../../services/schema/User'

const Main: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { state, dispatch: d } = useMainGlobalContext()

  const pathnameParts = location.pathname.split('/')

  const { data, isSuccess, isLoading, isError, error } =
    useGetUserWithTokenQuery(undefined, {
      refetchOnMountOrArgChange: false,
    })

  const user = useMemo(() => {
    if (isSuccess && data && isCurrentUser(data)) {
      return data
    }

    return undefined
  }, [isSuccess, data])

  useEffect(() => {
    if (isError) {
      navigate('/', { replace: true })
    }
  }, [isError, navigate])

  const loadingComponent = (
    <div className="flex h-dvh w-dvw items-center justify-center">
      <Spinner />
    </div>
  )

  return (
    <div className="flex h-full w-full">
      {isLoading && loadingComponent}
      {/* isError here is the fallback of fallbacks XD an infinite loading screen */}
      {isError && loadingComponent}
      {isSuccess && user && (
        <>
          {state.isPostOverlayOpen && (
            <Overlay profilePicture={user.profilePicture} />
          )}
          <Banner dispatch={d} user={user} />
          <div className="flex grow">
            <div
              className={clsx(
                'main-dynamic-gap relative flex justify-between',
                {
                  // for future removal... when we get to finally clean the css for this app
                  'remove-gap':
                    pathnameParts[1] === 'settings' &&
                    pathnameParts[2] !== 'profile',
                },
              )}
            >
              <Outlet context={user} />
            </div>
          </div>
          <CustomErrorDisplayWrapper />
        </>
      )}
    </div>
  )
}

export default Main
